import type { BaseHttpRequest } from './core/BaseHttpRequest'
import type { OpenAPIConfig } from './core/OpenAPI'
import { Interceptors } from './core/OpenAPI'
import { AxiosHttpRequest } from './core/AxiosHttpRequest'

import { AuthService } from './services.gen'
import { CustomFormsService } from './services.gen'
import { DebugService } from './services.gen'
import { GiveawayService } from './services.gen'
import { UserService } from './services.gen'

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest

export class MobileMissionsApiClient {
  public readonly auth: AuthService
  public readonly customForms: CustomFormsService
  public readonly debug: DebugService
  public readonly giveaway: GiveawayService
  public readonly user: UserService

  public readonly request: BaseHttpRequest

  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = AxiosHttpRequest
  ) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'https://missions.op-test.net',
      VERSION: config?.VERSION ?? '0.1.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
      interceptors: {
        request: config?.interceptors?.request ?? new Interceptors(),
        response: config?.interceptors?.response ?? new Interceptors()
      }
    })

    this.auth = new AuthService(this.request)
    this.customForms = new CustomFormsService(this.request)
    this.debug = new DebugService(this.request)
    this.giveaway = new GiveawayService(this.request)
    this.user = new UserService(this.request)
  }
}
